module.exports = __webpack_public_path__ + "img/随专微信公众号二维码.56b11df0.jpg";